<template>
  <v-layout>
    <d-header fluid>
      <h1 class="title">
        {{ $t("terms_and_conditions_title") }}
      </h1>
    </d-header>

    <d-container fluid>
      <d-card>
        <d-card-row>
          <v-terms-and-conditions />
        </d-card-row>
      </d-card>
    </d-container>
  </v-layout>
</template>

<script>

import TermsAndConditionsHtml from "@/shared/terms-and-conditions/TermsAndConditionsHtml.vue";

export default {
  metaInfo() {
    return {
      title: this.$t("terms_and_conditions").capitalize(),
    };
  },
  components: {
    "v-terms-and-conditions": TermsAndConditionsHtml,
  },
};
</script>
